/*
 * Copyright (c) 2023. All rights are reserved to Newport Collection
 */

import React from 'react';
import MetaTitle from '../../meta/title';
import MetaDescription from '../../meta/description';
import MetaCanonical from '../../meta/canonical';
import MetaUrl from "../../meta/url";
import Head from 'next/head';
import { useRouter } from 'next/router';
import countryMapping from '../../popup/countryMapping.json';
import MetaImage from "../../meta/image";

export default function CategoryMeta({ category, canonicalPath }) {
	const router = useRouter();
	function getTitle() {
		if (canonicalPath === '/' || category.translated.name.indexOf(' - Newport') > 0) {
			return category.translated.name;
		}

		return category.translated.name + ' - Newport';
	}

	function getMetaTitle() {
		let title = category.translated.metaTitle || category.translated.name;

		if (canonicalPath === '/' || title.indexOf(' - Newport') > 0) {
			return title;
		}

		return (category.translated.metaTitle || category.translated.name) + ' - Newport';
	}

	function isHomePage() {
		let baseUrl = router.asPath.split('?')[0];

		return baseUrl === '/';
	}

	function getHrefLangTags() {
		return Object.keys(countryMapping.websites).map(key => {
			let website = countryMapping.websites[key];
			let hreflang = key === 'eu' ? 'en' : website.languages[0] + '-' + website.countries[0];
			let hreflangShort = website.languages[0];
			return (
				<React.Fragment key={'rct-frg'+key}>
					<link rel="alternate" key={'hreflangkey-' + key} hrefLang={hreflang} href={website.url} />;
					{
						(key !== 'global' && key !== 'eu') &&
							<link rel="alternate" hrefLang={hreflangShort} href={website.url} />
					}
				</React.Fragment>
			);
		});
	}

	return (
		<>
			<MetaTitle title={getTitle()} metaTitle={getMetaTitle()} />
			<MetaDescription
				description={category.translated.metaDescription || category.translated.description || getMetaTitle()}
			/>
			<MetaCanonical canonicalPathInfo={canonicalPath} />
			<MetaImage image={category.media ? category.media.url : ''}/>
			<MetaUrl url={canonicalPath} />

			{isHomePage() ? <Head>{getHrefLangTags()}</Head> : ''}
		</>
	);
}
